(() => {
    let path = '';
    let body = '';
    let tabsContainerMobile = '';
    let tabsMobile = '';
    let tabsContainerDesktop = '';
    let tabsDesktop = '';
    let searchBanner = '';
    let vendors = [];
    let customStore = '';

    let menuPanelContainer = '';
    let menuPanelBrands = '';

    document.addEventListener("DOMContentLoaded", (ev) => {
        tabsContainerMobile = document.getElementsByClassName('header__brands-tab--mobile');
        tabsContainerDesktop = document.getElementsByClassName('header__brands-tab--desk');

        tabsDesktop = tabsContainerDesktop[0].getElementsByClassName('tab-item');
        tabsMobile = tabsContainerMobile[0].getElementsByClassName('tab-item');

        searchBanner = document.getElementsByClassName('search-banner')[0];

        menuPanelContainer = document.getElementsByClassName('panel__scroller');
        menuPanelBrands = menuPanelContainer[0].getElementsByClassName('panel__wrapper-linkist');

        if (window.location.pathname.includes('/search')) {
            path = window.location.search;
            body = document.getElementsByTagName('body');

            if (path.includes('store=Acento+Casa')) {
                vendors = ['Acento', 'Moorefield', 'Sheffield Labs', 'Decor Living', 'Flowell'];
                customStore = ['Acento Casa', 'Decor Living House'];

                removeSearchMobileBrandMenu('acento');

                setSearchBrandState('acento');

                customStore.forEach((store) => {
                    getSearchBanner(searchBanner, store, vendors);
                });

            } else if (path.includes('store=Decor+Living+House')) {
                vendors = ['Decor Living', 'Flowell', 'Acento', 'Moorefield', 'Sheffield Labs'];
                customStore = ['Decor Living House', 'Acento Casa'];

                removeSearchMobileBrandMenu('decor');

                setSearchBrandState('decor');

                customStore.forEach((store) => {
                    getSearchBanner(searchBanner, store, vendors);
                });
            } else {
                removeSearchMobileBrandMenu('acento');

                setSearchBrandState('acento');
            }
        }
    });

    function setSearchBrandState(brand) {
        let activeIndex = brand === 'decor' ? 1 : 0;
        let inactiveIndex = brand === 'decor' ? 0 : 1;

        body[0].classList.remove('font--general', 'font--acento', 'font--decor-living');
        body[0].classList.add(brand === 'decor' ? 'font--decor-living' : 'font--acento');
        body[0].setAttribute('data-brand', brand === 'decor' ? 'decor-living' : 'acento');
        body[0].setAttribute('data-brand-search', brand === 'decor' ? 'decor-living' : 'acento-casa');

        tabsMobile[inactiveIndex].classList.remove('is-active');
        tabsDesktop[inactiveIndex].classList.remove('is-active');
        tabsMobile[activeIndex].classList.add('is-active');
        tabsDesktop[activeIndex].classList.add('is-active');
    }

    function removeSearchMobileBrandMenu(brand) {
        let mobileMenuIndexToRemove = brand === 'decor' ? 0 : 1;

        if (menuPanelBrands[mobileMenuIndexToRemove]) {
            menuPanelBrands[mobileMenuIndexToRemove].remove();
        }
    }


    function getSearchBanner(searcher, store, vendors) {
        let searcherForm = searcher.getElementsByClassName('main-search-form')[0];
        let searcherFormNavbar = document.getElementsByClassName('search-form-navbar')[0];
        let newInputStore = document.createElement('input');
        let newInputStoreNavbar = document.createElement('input');

        vendors.forEach(vendor => {
            let newInput = document.createElement('input');
            newInput.setAttribute('type', 'hidden');
            newInput.setAttribute('name', 'filter.p.vendor');
            newInput.setAttribute('value', vendor);

            let newInputNavbar = document.createElement('input');
            newInputNavbar.setAttribute('type', 'hidden');
            newInputNavbar.setAttribute('name', 'filter.p.vendor');
            newInputNavbar.setAttribute('value', vendor);

            searcherFormNavbar.appendChild(newInputNavbar);
            searcherForm.appendChild(newInput);
        });

        newInputStore.setAttribute('type', 'hidden');
        newInputStore.setAttribute('name', 'filter.p.m.custom.store');
        newInputStore.setAttribute('value', store);

        newInputStoreNavbar.setAttribute('type', 'hidden');
        newInputStoreNavbar.setAttribute('name', 'filter.p.m.custom.store');
        newInputStoreNavbar.setAttribute('value', store);

        searcherFormNavbar.appendChild(newInputStoreNavbar);
        searcherForm.appendChild(newInputStore);
    }

})();
